"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class Profile extends __1.OMObject {
    constructor(object) {
        super(object);
        this.user = new __1.OMReference(__1.OMUser, object.user);
    }
    static FromJson(object) {
        const profileProperties = Object.assign({}, object, super.FromJson(object), {
            user: new __1.OMReference(__1.OMUser, object.user),
        });
        if (object.user) {
            __1.OMUniverse.shared.touch(object.user);
        }
        return new Profile(profileProperties);
    }
}
Profile.Type = "profile";
Profile.Path = "profiles";
exports.default = Profile;
//# sourceMappingURL=Profile.js.map